import cloneDeep from 'lodash/cloneDeep';

import type { MailSettings } from './mailing';
import { initialMailSettings } from './mailing';

export interface SettingsState {
    fetch: boolean;
    mailSettings: MailSettings;
    charts: Record<string, any>;
    questionPresetColors: Array<string> | null;
}

export const initialState: SettingsState = {
    fetch: true,
    mailSettings: cloneDeep(initialMailSettings),
    charts: {},
    questionPresetColors: null,
};
